import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import { isBoolean } from 'lodash';
import { hiscoxClassServiceArchitectureKey, hiscoxClassServiceITConsultingKey, hiscoxClassServiceLandscapeArchitectKey, hiscoxClassServiceSoftwareDevelopmentsKey, payrollCobsListFromGreatAmericanBusinessInsurance, payrollCobsListFromHiscox } from '../../constants';
import { BUSINESS_INTERUPTION, BUSINESS_OWNERS_POLICY_COVER, CYBER_LIABILITY_COVER, EMPLOYERS_LIABILITY, PORTABLE_EQUIPMENT_COVER, PROPERTY_COVER, PUBLIC_LIABILITY } from '../../constants/coverage';
import { PROFESSIONAL_INDEMNITY } from '../../constants/coverage';
import { greateAmericanTypeOfOperationCourier, typeOfOperationList } from '../../constants/greateAmerican';
import { PROVIDER_SOURCE, UKCountryList } from '../../constants/quote';
import { JoveProjectTypeEnum } from '../../enums/common';
import { judgeCanChooseAccountancyActivities, judgeQuoteIsCombineR2RScheme, judgeQuoteIsR2RScheme } from '../../flagJudgement/quote';
import { BusinessTypeSoleTrader, getQuoteRecruitmentBusinessTypeMap } from '../../localeConstants';
import { judgeWhetherShowCMRRequireSelectOptions } from '../../utils/coverage';
import { QuoteFormSectionTitleInfoEnum, getQuoteFormDisplayTitleInfo } from '../../utils/quote/formDisplayTitle';
import { useQuoteHearAboutUs } from './useQuoteHearAboutUs';
export { QuoteFormSectionTitleInfoEnum };
export var useQuoteDataFormDisplayMap = function useQuoteDataFormDisplayMap() {
  var _useState = useState({
    contactInfo: true,
    businessType: true,
    companyAndAddress: true,
    retroactiveDate: false,
    policyStartDate: true,
    businessActivity: true,
    recruitmentBusinessType: false,
    estimatedTurnover: true,
    recruitmentEstimatedSplit: false,
    incomeSplit: true,
    numberOfEmployees: true,
    payrollForPlacedCandidates: false,
    placedCandidateSplit: false,
    recruitmentNotContractuallyResponsibleQuestion: false,
    recruitmentPlacementsWithinWhiteCollar: false,
    placementIndustriesPercentage: false,
    employerReferenceNumber: false,
    coverType: false,
    covers: true,
    claims: false,
    typeOfPolicy: false,
    insuranceBundle: false,
    employees: false,
    vehicles: false,
    personalData: false,
    portableEquipmentInsured: false,
    businessInterruptionInsured: false,
    propertyList: false,
    fastFlow: false,
    dotNumber: false,
    typeOfRemovalJob: false,
    useWhatCar: false,
    mixedCourierWork: false,
    averageRadiusOperation: false,
    cargoLoses: false,
    yearsOfExperience: false,
    numberOfDrivers: false,
    driversAgeRange: false,
    numberOfMinorViolations: false,
    acceptanceCriteria: false,
    accountancyActivities: false,
    professionalAssociationsMember: false,
    integratedInsuranceDeskSchemeAcceptance: false,
    r2rOption: false,
    hearAboutUs: false,
    coveragEUConfiguration: false,
    typeOfCommodities: false,
    numberOfLosses: false,
    driversAgeRangeAcceptableDot: false,
    businessExpectedRevenue: false,
    estSalesLargestProject: false,
    expectedGrossSalesFromCustomer: false,
    businessClass: false,
    businessBegin: false,
    operatedFromHome: false,
    squareFeetOccupiedByYou: false,
    estmtdPayrollExpense: false,
    numOfOwners: false,
    annualPrivacyMattersTraining: false,
    buildingOwnership: false,
    professionalLicenseAttestation: false,
    subcontractProfessionalServices: false,
    subcontractProfessionalServices2: false,
    designConstructionRepair: false,
    designConstructionRepair2: false,
    berAssessor: false,
    staffExperienceYears: false,
    reviewedByLegalCounsel: false,
    writtenOrStandardOperatingProcedures: false,
    workRequireCertified: false,
    limitationLiabilityContract: false,
    contractsDefineScopeServices: false,
    conductedBySubcontractors: false,
    revenueFromSingleClient: false,
    pastProfessionalLiabilityClaims: false,
    purchaseMergerSupplement: false,
    workRequireCertifiedPercentage: false,
    writtenContractPercentage: false,
    subcontractorPercentage: false,
    totalCostClaims: false,
    totalInsurancePremiumPaid: false,
    insurancePolicyInEffect: false,
    professionalLiabilityPolicyAndRetroactiveDate: false,
    tangibleGoodsOrProducts: false,
    productsManufacturedByOthers: false,
    limitedItemsPartOfServices: false,
    riskManagement: false,
    itConsultingOrTechnologyServices: false,
    quickJourneyCriteria: false,
    limitedEmployeeCount: false,
    cyberPolicyAndRetroactiveDate: false,
    cyberMediaPolicyAndRetroactiveDate: false
  }),
      formDataDisplayMap = _useState[0],
      setFormDataDisplayMap = _useState[1];

  var _useQuoteHearAboutUs = useQuoteHearAboutUs(),
      judgeWhetherShowHearAboutUs = _useQuoteHearAboutUs.judgeWhetherShowHearAboutUs;
  /**
   * methods
   */


  var getFormDataDisplayMapWithQuoteData = function getFormDataDisplayMapWithQuoteData(data, config) {
    var _declarationQuestions2, _declarationQuestions3, _declarationQuestions4, _declarationQuestions5, _declarationQuestions6, _declarationQuestions7, _declarationQuestions8, _declarationQuestions9, _declarationQuestions10, _declarationQuestions11, _declarationQuestions12, _declarationQuestions13, _declarationQuestions14;

    var providerCode = data.providerCode,
        recruitmentBusinessType = data.recruitmentBusinessType,
        temporarySplitPercentForPlacedCandidate = data.temporarySplitPercentForPlacedCandidate,
        declarationQuestions = data.declarationQuestions,
        turnoverRaw = data.turnoverRaw,
        businessType = data.businessType,
        covers = data.covers,
        detailSource = data.detailSource,
        businessActivity = data.businessActivity,
        promotionInfo = data.promotionInfo,
        source = data.source,
        country = data.country,
        isSimpleFlow = data.isSimpleFlow,
        typeOfOperation = data.typeOfOperation,
        similarInsurance = data.similarInsurance; // Flag

    var isQuoteProject = (config === null || config === void 0 ? void 0 : config.projectSource) === JoveProjectTypeEnum.quote;
    var isCMSProject = (config === null || config === void 0 ? void 0 : config.projectSource) === JoveProjectTypeEnum.cms;
    var isGreatAmerican = [PROVIDER_SOURCE().GREATEAMERICAN.value].includes(providerCode);
    var isRecruitment = [PROVIDER_SOURCE().RECRUITMENT.value].includes(providerCode);
    var isAccelerant = [PROVIDER_SOURCE().ACCELERANT.value].includes(providerCode);
    var isAccelerantGit = [PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(providerCode);
    var isHiscoxUS = [PROVIDER_SOURCE().HISCOX_US.value].includes(providerCode);
    var isGreatAmericanBusiness = [PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value].includes(providerCode);
    var haveSelectedPI = !!(covers !== null && covers !== void 0 && covers[PROFESSIONAL_INDEMNITY]);
    var haveSelectedPL = !!(covers !== null && covers !== void 0 && covers[PUBLIC_LIABILITY]);
    var haveSelectedBOP = !!(covers !== null && covers !== void 0 && covers[BUSINESS_OWNERS_POLICY_COVER]);
    var haveSelectedCyber = !!(covers !== null && covers !== void 0 && covers[CYBER_LIABILITY_COVER]);
    var haveSelectedEL = !!(covers !== null && covers !== void 0 && covers[EMPLOYERS_LIABILITY]);
    var quoteIsCombineR2RScheme = judgeQuoteIsCombineR2RScheme({
      dataHandleSourceKey: config === null || config === void 0 ? void 0 : config.promotionInfoPayloadKey,
      promotionInfo: _objectSpread(_objectSpread({}, promotionInfo), {}, {
        payload: promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo[config === null || config === void 0 ? void 0 : config.promotionInfoPayloadKey]
      })
    });
    var isFastFlow = !!isSimpleFlow;

    if ([PROVIDER_SOURCE().GREATEAMERICAN.value, PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value].includes(providerCode)) {
      var _declarationQuestions;

      isFastFlow = isFastFlow || (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions = declarationQuestions['great_american_fast_process_criteria']) === null || _declarationQuestions === void 0 ? void 0 : _declarationQuestions.truelyValue) === true;
    }

    var typeOfOperationIsNotInOther = !!typeOfOperationList.find(function (item) {
      return item.value === typeOfOperation;
    });
    return {
      contactInfo: true,
      businessType: true,
      companyAndAddress: true,
      policyStartDate: true,
      businessActivity: true,
      covers: true,
      estimatedTurnover: true,
      incomeSplit: true,
      retroactiveDate: !(isAccelerantGit || isGreatAmerican || isHiscoxUS),
      recruitmentBusinessType: isRecruitment,
      numberOfEmployees: isAccelerant && !quoteIsCombineR2RScheme && (haveSelectedEL || source === 'Acturis'),
      recruitmentEstimatedSplit: isRecruitment && [getQuoteRecruitmentBusinessTypeMap().recruitmentAgencyIncludingUmbrellaPayrollActivities.value].includes(recruitmentBusinessType),
      payrollForPlacedCandidates: isRecruitment && [getQuoteRecruitmentBusinessTypeMap().umbrellaPayrollBusiness.value, getQuoteRecruitmentBusinessTypeMap().recruitmentAgencyIncludingUmbrellaPayrollActivities.value].includes(recruitmentBusinessType),
      placedCandidateSplit: isRecruitment && [getQuoteRecruitmentBusinessTypeMap().recruitmentAgency.value, getQuoteRecruitmentBusinessTypeMap().recruitmentAgencyIncludingUmbrellaPayrollActivities.value].includes(recruitmentBusinessType),
      recruitmentNotContractuallyResponsibleQuestion: isRecruitment && [getQuoteRecruitmentBusinessTypeMap().recruitmentAgency.value, getQuoteRecruitmentBusinessTypeMap().recruitmentAgencyIncludingUmbrellaPayrollActivities.value].includes(recruitmentBusinessType) && Number(temporarySplitPercentForPlacedCandidate || 0) > 0,
      recruitmentPlacementsWithinWhiteCollar: isRecruitment && [getQuoteRecruitmentBusinessTypeMap().recruitmentAgency.value, getQuoteRecruitmentBusinessTypeMap().recruitmentAgencyIncludingUmbrellaPayrollActivities.value].includes(recruitmentBusinessType) && Number(temporarySplitPercentForPlacedCandidate || 0) > 0,
      placementIndustriesPercentage: isRecruitment && [getQuoteRecruitmentBusinessTypeMap().recruitmentAgency.value, getQuoteRecruitmentBusinessTypeMap().recruitmentAgencyIncludingUmbrellaPayrollActivities.value].includes(recruitmentBusinessType) && Number(temporarySplitPercentForPlacedCandidate || 0) > 0 && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions2 = declarationQuestions.placements_within_white_collar) === null || _declarationQuestions2 === void 0 ? void 0 : _declarationQuestions2.truelyValue) === false,
      employerReferenceNumber: isRecruitment && UKCountryList.includes(country),
      coverType: (isRecruitment || isAccelerant) && !quoteIsCombineR2RScheme && (isCMSProject ? true : Number(turnoverRaw || 0) >= 2000000),
      claims: isRecruitment || isAccelerant && Number(turnoverRaw || 0) >= 2000000,
      typeOfPolicy: isAccelerant,
      insuranceBundle: isAccelerantGit,
      employees: isAccelerantGit || isRecruitment || isHiscoxUS && (haveSelectedBOP || haveSelectedCyber),
      vehicles: isAccelerantGit || isGreatAmerican,
      personalData: isAccelerantGit && businessType === BusinessTypeSoleTrader,
      portableEquipmentInsured: (isAccelerant || isRecruitment) && !!(covers !== null && covers !== void 0 && covers[PORTABLE_EQUIPMENT_COVER]),
      businessInterruptionInsured: (isAccelerant || isRecruitment) && !!(covers !== null && covers !== void 0 && covers[BUSINESS_INTERUPTION]),
      propertyList: (isAccelerant || isRecruitment) && !!(covers !== null && covers !== void 0 && covers[PROPERTY_COVER]),
      fastFlow: isGreatAmerican && detailSource !== 'policy',
      dotNumber: isGreatAmerican,
      typeOfRemovalJob: isGreatAmerican,
      useWhatCar: isGreatAmerican && !isFastFlow && typeOfOperation === greateAmericanTypeOfOperationCourier,
      mixedCourierWork: isGreatAmerican && !isFastFlow && !!typeOfOperation && typeOfOperationIsNotInOther,
      typeOfCommodities: isGreatAmerican && !isFastFlow && !!typeOfOperation && (!typeOfOperationIsNotInOther || typeOfOperationIsNotInOther && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions3 = declarationQuestions.greate_american_mixed_courier_work) === null || _declarationQuestions3 === void 0 ? void 0 : _declarationQuestions3.truelyValue) === true),
      averageRadiusOperation: isGreatAmerican && !isFastFlow,
      cargoLoses: isGreatAmerican,
      numberOfLosses: isGreatAmerican && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions4 = declarationQuestions.greate_american_cargo_loses) === null || _declarationQuestions4 === void 0 ? void 0 : _declarationQuestions4.truelyValue) === true,
      yearsOfExperience: isGreatAmerican && !isFastFlow,
      numberOfDrivers: isGreatAmerican,
      driversAgeRange: isGreatAmerican && !isFastFlow,
      driversAgeRangeAcceptableDot: isGreatAmerican && !isFastFlow && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions5 = declarationQuestions.greate_american_drivers_age_range) === null || _declarationQuestions5 === void 0 ? void 0 : _declarationQuestions5.truelyValue) === false,
      numberOfMinorViolations: isGreatAmerican && !isFastFlow,
      acceptanceCriteria: isGreatAmerican,
      accountancyActivities: isAccelerant && judgeCanChooseAccountancyActivities(businessActivity),
      professionalAssociationsMember: isAccelerant && judgeCanChooseAccountancyActivities(businessActivity),
      integratedInsuranceDeskSchemeAcceptance: isAccelerant && quoteIsCombineR2RScheme,
      r2rOption: isAccelerant && judgeQuoteIsR2RScheme({
        dataHandleSourceKey: config === null || config === void 0 ? void 0 : config.promotionInfoPayloadKey,
        promotionInfo: _objectSpread(_objectSpread({}, promotionInfo), {}, {
          payload: promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo[config === null || config === void 0 ? void 0 : config.promotionInfoPayloadKey]
        })
      }),
      hearAboutUs: (isAccelerant || isAccelerantGit || isRecruitment) && judgeWhetherShowHearAboutUs(promotionInfo, {
        payloadKey: config === null || config === void 0 ? void 0 : config.promotionInfoPayloadKey
      }),
      coveragEUConfiguration: isAccelerantGit && judgeWhetherShowCMRRequireSelectOptions({
        providerCode: providerCode,
        country: country
      }),
      businessExpectedRevenue: isHiscoxUS || isGreatAmericanBusiness,
      estSalesLargestProject: isHiscoxUS && haveSelectedPI && [hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(businessActivity),
      expectedGrossSalesFromCustomer: isHiscoxUS && haveSelectedPI && ![hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(businessActivity),
      businessClass: isHiscoxUS || isGreatAmericanBusiness,
      businessBegin: isHiscoxUS || isGreatAmericanBusiness,
      operatedFromHome: isHiscoxUS && (haveSelectedPL || haveSelectedBOP),
      buildingOwnership: isHiscoxUS && haveSelectedBOP && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions6 = declarationQuestions['hiscox_operated_from_home_question']) === null || _declarationQuestions6 === void 0 ? void 0 : _declarationQuestions6.truelyValue) === false,
      squareFeetOccupiedByYou: isHiscoxUS && (haveSelectedPL || haveSelectedBOP),
      estmtdPayrollExpense: isHiscoxUS && (haveSelectedPL || haveSelectedBOP),
      numOfOwners: isHiscoxUS && haveSelectedPL && [].concat(_toConsumableArray(payrollCobsListFromGreatAmericanBusinessInsurance), _toConsumableArray(payrollCobsListFromHiscox)).includes(businessActivity),
      annualPrivacyMattersTraining: isHiscoxUS && haveSelectedCyber,
      professionalLicenseAttestation: isHiscoxUS && haveSelectedPI && [hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(businessActivity),
      insurancePolicyInEffect: isHiscoxUS,
      subcontractProfessionalServices: isHiscoxUS && (haveSelectedPI || haveSelectedPL || haveSelectedBOP) && [hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(businessActivity),
      subcontractProfessionalServices2: isHiscoxUS && (haveSelectedPI || haveSelectedPL || haveSelectedBOP) && [hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(businessActivity) && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions7 = declarationQuestions['hiscox_subcontract_professional_services_question_1']) === null || _declarationQuestions7 === void 0 ? void 0 : _declarationQuestions7.truelyValue) === true,
      designConstructionRepair: isHiscoxUS && (haveSelectedPL || haveSelectedBOP) && ![hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(businessActivity),
      designConstructionRepair2: isHiscoxUS && (haveSelectedPL || haveSelectedBOP) && ![hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(businessActivity) && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions8 = declarationQuestions['hiscox_design_construction_repair_question_1']) === null || _declarationQuestions8 === void 0 ? void 0 : _declarationQuestions8.truelyValue) === true,
      berAssessor: ['BCS-290'].includes(businessActivity),
      staffExperienceYears: isGreatAmericanBusiness,
      reviewedByLegalCounsel: isGreatAmericanBusiness,
      writtenOrStandardOperatingProcedures: isGreatAmericanBusiness,
      workRequireCertified: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true),
      limitationLiabilityContract: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true),
      contractsDefineScopeServices: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true),
      conductedBySubcontractors: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true),
      revenueFromSingleClient: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true),
      pastProfessionalLiabilityClaims: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true),
      purchaseMergerSupplement: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true),
      workRequireCertifiedPercentage: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true) && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions9 = declarationQuestions['greate_american_us_work_require_certified']) === null || _declarationQuestions9 === void 0 ? void 0 : _declarationQuestions9.truelyValue) === true,
      writtenContractPercentage: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true),
      subcontractorPercentage: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true) && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions10 = declarationQuestions['greate_american_us_conducted_by_subcontractors']) === null || _declarationQuestions10 === void 0 ? void 0 : _declarationQuestions10.truelyValue) === true,
      totalCostClaims: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true) && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions11 = declarationQuestions['greate_american_us_past_professional_liability_claims']) === null || _declarationQuestions11 === void 0 ? void 0 : _declarationQuestions11.truelyValue) === true,
      totalInsurancePremiumPaid: isGreatAmericanBusiness && (isQuoteProject ? isFastFlow : true) && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions12 = declarationQuestions['greate_american_us_past_professional_liability_claims']) === null || _declarationQuestions12 === void 0 ? void 0 : _declarationQuestions12.truelyValue) === true,
      professionalLiabilityPolicyAndRetroactiveDate: isHiscoxUS && haveSelectedPI && [hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(businessActivity) && similarInsurance === 'Yes',
      tangibleGoodsOrProducts: isHiscoxUS && (haveSelectedPL || haveSelectedBOP) && ![hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(businessActivity),
      productsManufacturedByOthers: isHiscoxUS && (haveSelectedPL || haveSelectedBOP) && ![hiscoxClassServiceSoftwareDevelopmentsKey, hiscoxClassServiceITConsultingKey, hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(businessActivity) && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions13 = declarationQuestions['hiscox_tangible_goods_or_products_question']) === null || _declarationQuestions13 === void 0 ? void 0 : _declarationQuestions13.truelyValue) === true,
      limitedItemsPartOfServices: isHiscoxUS && (haveSelectedPL || haveSelectedBOP) && [hiscoxClassServiceSoftwareDevelopmentsKey, hiscoxClassServiceITConsultingKey].includes(businessActivity) && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions14 = declarationQuestions['hiscox_tangible_goods_or_products_question']) === null || _declarationQuestions14 === void 0 ? void 0 : _declarationQuestions14.truelyValue) === true,
      riskManagement: isHiscoxUS && haveSelectedPI,
      itConsultingOrTechnologyServices: isHiscoxUS && haveSelectedPI && [hiscoxClassServiceSoftwareDevelopmentsKey, hiscoxClassServiceITConsultingKey].includes(businessActivity),
      quickJourneyCriteria: isGreatAmerican || isGreatAmericanBusiness,
      limitedEmployeeCount: isHiscoxUS && haveSelectedPL && [].concat(_toConsumableArray(payrollCobsListFromGreatAmericanBusinessInsurance), _toConsumableArray(payrollCobsListFromHiscox)).includes(businessActivity),
      cyberPolicyAndRetroactiveDate: isHiscoxUS && haveSelectedCyber,
      cyberMediaPolicyAndRetroactiveDate: isHiscoxUS && haveSelectedCyber
    };
  };

  var updateFormDataDisplayMapWithQuoteData = function updateFormDataDisplayMapWithQuoteData(data, config) {
    setFormDataDisplayMap(getFormDataDisplayMapWithQuoteData(data, config)); // const tempData = getFormDataDisplayMapWithQuoteData(data, config);
    // Object.keys(tempData).forEach((key) => {
    //   tempData[key] = true;
    // });
    // setFormDataDisplayMap(tempData);
  };

  var judgeQuoteFormDataValidInfo = function judgeQuoteFormDataValidInfo(data) {
    var _Object$keys;

    var providerCode = data.providerCode,
        haveDotNumber = data.haveDotNumber,
        typeOfOperation = data.typeOfOperation,
        averageRadiusOfOperation = data.averageRadiusOfOperation,
        yearsInBusiness = data.yearsInBusiness,
        numberOfDrivers = data.numberOfDrivers,
        minorViolations = data.minorViolations,
        businessType = data.businessType,
        companyName = data.companyName,
        businessAddress = data.businessAddress,
        businessCity = data.businessCity,
        businessPostcode = data.businessPostcode,
        policyType = data.policyType,
        businessActivity = data.businessActivity,
        turnoverRaw = data.turnoverRaw,
        elSize = data.elSize,
        coverType = data.coverType,
        hasClaims = data.hasClaims,
        claimList = data.claimList,
        portableEquipmentInsured = data.portableEquipmentInsured,
        businessInterruptionInsured = data.businessInterruptionInsured,
        birthDate = data.birthDate,
        insuranceBundle = data.insuranceBundle,
        employees = data.employees,
        vehicleList = data.vehicleList,
        recruitmentBusinessType = data.recruitmentBusinessType,
        recruitmentSplitPercent = data.recruitmentSplitPercent,
        payrollSplitPercent = data.payrollSplitPercent,
        payrollForPlacedCandidate = data.payrollForPlacedCandidate,
        permanentSplitPercentForPlacedCandidate = data.permanentSplitPercentForPlacedCandidate,
        temporarySplitPercentForPlacedCandidate = data.temporarySplitPercentForPlacedCandidate,
        placementTypeAndSplitList = data.placementTypeAndSplitList,
        r2ROption = data.r2ROption,
        estSalesLargestProject = data.estSalesLargestProject,
        estSalesLargestCustmr1 = data.estSalesLargestCustmr1,
        membership = data.membership,
        activitySplit = data.activitySplit,
        companyIncorporationDate = data.companyIncorporationDate,
        squareFeetOccupiedByYou = data.squareFeetOccupiedByYou,
        estmtdPayrollExpense = data.estmtdPayrollExpense,
        numOfOwners = data.numOfOwners,
        professionalLicenseAttestation = data.professionalLicenseAttestation,
        staffExperienceYears = data.staffExperienceYears,
        workRequireCertifiedPercentage = data.workRequireCertifiedPercentage,
        writtenContractPercentage = data.writtenContractPercentage,
        subcontractorPercentage = data.subcontractorPercentage,
        totalCostClaims = data.totalCostClaims,
        totalInsurancePremiumPaid = data.totalInsurancePremiumPaid,
        similarInsurance = data.similarInsurance,
        limitedEmployeeCount = data.limitedEmployeeCount;
    var isAccelerant = [PROVIDER_SOURCE().ACCELERANT.value].includes(providerCode);
    var isAcceelerantGit = [PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(providerCode);
    var isRecruitment = [PROVIDER_SOURCE().RECRUITMENT.value].includes(providerCode); // Total

    var placementTypeAndSplitListTotal = 0;
    (placementTypeAndSplitList || []).forEach(function (item) {
      placementTypeAndSplitListTotal += Number(item.percent || 0);
    });
    return {
      dotNumber: {
        isValid: isBoolean(haveDotNumber)
      },
      typeOfOperation: {
        isValid: !!typeOfOperation
      },
      averageRadiusOfOperation: {
        isValid: !!averageRadiusOfOperation
      },
      yearsInBusiness: {
        isValid: !!yearsInBusiness
      },
      numberOfDrivers: {
        isValid: !!numberOfDrivers
      },
      minorViolations: {
        isValid: !!minorViolations || minorViolations === 0
      },
      businessType: {
        isValid: !!businessType
      },
      companyAddress: {
        isValid: isAccelerant ? !!(companyName && businessAddress && businessCity && businessPostcode) : true
      },
      policyType: {
        isValid: !!policyType
      },
      businessActivity: {
        isValid: !!businessActivity
      },
      turnoverRaw: {
        isValid: !!turnoverRaw
      },
      compositionEmployees: {
        isValid: !!(elSize !== null && elSize !== void 0 && elSize.clericalEmployees) || !!(elSize !== null && elSize !== void 0 && elSize.manualEmployees)
      },
      coverType: {
        isValid: !!coverType
      },
      claims: {
        isValid: !hasClaims || !!hasClaims && (claimList === null || claimList === void 0 ? void 0 : claimList.length) > 0
      },
      portableEquipmentInsured: {
        isValid: !!portableEquipmentInsured
      },
      businessInterruptionInsured: {
        isValid: !!businessInterruptionInsured
      },
      birthDate: {
        isValid: !!birthDate
      },
      insuranceBundle: {
        isValid: !!insuranceBundle
      },
      employees: {
        isValid: !!employees
      },
      numOfOwners: {
        isValid: !!numOfOwners
      },
      squareFeetOccupiedByYou: {
        isValid: !!squareFeetOccupiedByYou
      },
      vehicleList: {
        isValid: (vehicleList === null || vehicleList === void 0 ? void 0 : vehicleList.length) > 0
      },
      recruitmentBusinessType: {
        isValid: !!recruitmentBusinessType
      },
      recruitmentEstimatedSplit: {
        isValid: Number(recruitmentSplitPercent || 0) + Number(payrollSplitPercent || 0) === 100
      },
      payrollForPlacedCandidate: {
        isValid: !!payrollForPlacedCandidate
      },
      placedCandidateSplit: {
        isValid: Number(permanentSplitPercentForPlacedCandidate || 0) + Number(temporarySplitPercentForPlacedCandidate || 0) === 100
      },
      placementTypeAndSplitList: {
        isValid: placementTypeAndSplitListTotal === 100
      },
      r2ROption: {
        isValid: !!r2ROption
      },
      businessExpectedRevenue: {
        isValid: !!turnoverRaw
      },
      estSalesLargestProject: {
        isValid: !!estSalesLargestProject
      },
      expectedGrossSalesFromCustomer: {
        isValid: !!estSalesLargestCustmr1
      },
      professionalAssociationsMember: {
        isValid: !!membership
      },
      accountancyActivityList: {
        isValid: ((_Object$keys = Object.keys(activitySplit || {})) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0
      },
      companyIncorporationDate: {
        isValid: !!companyIncorporationDate
      },
      estmtdPayrollExpense: {
        isValid: !!estmtdPayrollExpense
      },
      professionalLicenseAttestation: {
        isValid: !!professionalLicenseAttestation
      },
      staffExperienceYears: {
        isValid: !!staffExperienceYears
      },
      workRequireCertifiedPercentage: {
        isValid: !!workRequireCertifiedPercentage
      },
      writtenContractPercentage: {
        isValid: !!writtenContractPercentage
      },
      subcontractorPercentage: {
        isValid: !!subcontractorPercentage
      },
      totalCostClaims: {
        isValid: !!totalCostClaims
      },
      totalInsurancePremiumPaid: {
        isValid: !!totalInsurancePremiumPaid
      },
      insurancePolicyInEffect: {
        isValid: !!similarInsurance
      },
      limitedEmployeeCount: {
        isValid: !!limitedEmployeeCount
      }
    };
  };

  return {
    formDataDisplayMap: formDataDisplayMap,
    getFormDataDisplayMapWithQuoteData: getFormDataDisplayMapWithQuoteData,
    updateFormDataDisplayMapWithQuoteData: updateFormDataDisplayMapWithQuoteData,
    getQuoteFormDisplayTitleInfo: getQuoteFormDisplayTitleInfo,
    judgeQuoteFormDataValidInfo: judgeQuoteFormDataValidInfo
  };
};